module.exports = __webpack_public_path__ + "static/media/Logo.d0e9bf08.svg";